
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar} from 'react-bootstrap'
import Select from 'react-select'
import AutopartStore from '../../stores/AutopartStore'
class SWTWageItemEditModal extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initItem()
  }

  initItem(){
    let {type} = this.props
    let title = ''
    if (type==='damage')
      title = 'เพิ่มรายการอาการ'
    else
      title = 'เพิ่มรายการค่าแรง'
    return {itemcode:'',catSelect:null,description:'',price:'',title:title,solution:''}
  }

  loadItemcode(item){
    if(item!==null) {
      let {type} = this.props
      let title = ''
      if (type==='damage')
        title = 'แก้ไขรายการอาการ'
      else
        title = 'แก้ไขรายการค่าแรง'
      this.setState({title:title,solution:item.solution,itemcode:item.itemcode,description:item.description,price:item.price,catSelect:this.getSelectOption(item.category_id)})
    } else{
      this.setState(this.initItem)
    }
  }

  getSelectOption(categoryId){
    let catSelect = null
    this.props.catOptions.forEach((item,index)=>{
      if(item.value===categoryId){
        catSelect = item
      }
    })

    return catSelect

  }

  onTextChange(e){
    this.setState({description:e.target.value})
  }

  onPriceChange(e){
    this.setState({price:e.target.value})
  }

  onServiceCodeChange(e){
    this.setState({servicecode:e.target.value})
  }

  onSolutionChange(e){
    this.setState({solution:e.target.value})
  }

  onSelectChange(value){
    // let {catSelect} = this.state

    this.setState({catSelect:value})
  }



  onSaveClick(){
    let that = this
    let {type} = this.props
    let {itemcode,description,catSelect,price,solution} = this.state
    let postData = {itemcode:itemcode,description:description,category_id:catSelect.value,price:price}
    if (type==='damage') {
      postData = Object.assign({solution:solution,type_id:(catSelect!==null?catSelect.value:'')}, postData)
      AutopartStore.saveDamageItemcode(postData,function(){
        that.props.onAfterSubmit();
        that.props.onHide()
      })
    } else {
      postData = Object.assign({price:price,category_id:(catSelect!==null?catSelect.value:'')}, postData)
      AutopartStore.saveWageItemcode(postData,function(){
        that.props.onAfterSubmit();
        that.props.onHide()
      })
    }  
  }

  onDelClick(){
    let that = this
    let {itemcode} = this.state
    let {type} = this.props
    if (type==='damage') {
      AutopartStore.delDamageItemcode(itemcode,function(){
        that.props.onAfterSubmit();
        that.props.onHide()
      })
    } else {    
      AutopartStore.delWageItemcode(itemcode,function(){
        that.props.onAfterSubmit();
        that.props.onHide()
      })
    }  
  }

  // renderHeader(){
  //   return (
  //     <div className='row form-group'>
  //       <div className='col-md-3'>
  //         หมวดหมู่
  //       </div>
  //       <div className='col-md-6'>
  //         รายการ
  //       </div>
  //       <div className='col-md-3'>
  //         ราคา
  //       </div>
  //     </div>        
  //   )
  // }

  // renderForm(){
  //   let {catSelect,description,price} = this.state
  //   let {catOptions} = this.props
  //   return (
  //     <div className='row form-group'>
  //       <div className='col-md-3'>
  //         <Select value={catSelect} placeholder={'เลือกหมวดหมู่'} options={catOptions} onChange={this.onSelectChange.bind(this)}/>
  //       </div> 
  //       <div className='col-md-6' style={{display:'inline-flex'}}>
  //         <FormControl value={description} onChange={this.onTextChange.bind(this)}/>          
  //       </div> 
  //       <div className='col-md-3' style={{display:'inline-flex'}}>
  //         <FormControl className='text-right' value={price} onChange={this.onPriceChange.bind(this)}/>          
  //       </div> 

  //     </div>
  //   )
  // }

  renderForm(){
    let {catSelect,servicecode,description,price,solution} = this.state
    let {catOptions,type} = this.props
    return (
        <div>
          <div className='row form-group'>
            <div className='col-md-2'>
              หมวดหมู่
            </div>
            <div className='col-md-2'>
              รหัสรายการ
            </div>
            <div className='col-md-6'>
              รายการ
            </div>
            {type==='wage'?
            <div className='col-md-2'>
              ราคา
            </div>
            :''}
          </div>
          <div className='row form-group'>
            <div className='col-md-2'>
              <Select value={catSelect} placeholder={'เลือกหมวดหมู่'} options={catOptions} onChange={this.onSelectChange.bind(this)}/>
            </div> 
            <div className='col-md-2' style={{display:'inline-flex'}}>
              <FormControl className='text-center' value={servicecode} onChange={this.onServiceCodeChange.bind(this)}/>          
            </div>
            <div className='col-md-6' style={{display:'inline-flex'}}>
              <FormControl value={description} onChange={this.onTextChange.bind(this)}/>          
            </div> 
            {type==='wage'?
            <div className='col-md-2' style={{display:'inline-flex'}}>
              <FormControl className='text-right' value={price} onChange={this.onPriceChange.bind(this)}/>          
            </div> 
            :''}
          </div>
          {type==='damage'?
          <div className='row form-group'>
            <div className='col-md-4'>
              วิธีตรวจเช็ค และแก้ไข
            </div>
          </div>
          :''}
          {type==='damage'?
          <div className='row form-group'>
            <div className='col-md-10'>
              <FormControl componentClass='textarea' rows={5} value={solution} onChange={this.onSolutionChange.bind(this)} />
            </div>
          </div>  
          :''}
        </div>  
    )
  }

  render(){
    let {show} = this.props
    let {itemcode} = this.state
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'แก้ไขรายการค่าแรง'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {this.renderHeader()} */}
          {this.renderForm()}
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button style={{display:(itemcode!=='')?'block':'none'}} bsStyle={'danger'}  onClick={this.onDelClick.bind(this)}>ลบข้อมูล</Button>
            <Button bsStyle={'primary'}  onClick={this.onSaveClick.bind(this)}>บันทึกข้อมูล</Button>
            <Button onClick={this.props.onHide}>ยกเลิก</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }
}

SWTWageItemEditModal.defaultProps = {
  type: 'wage'
}

export default SWTWageItemEditModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTWageItemEditModal.js